/** Chat copy for naming a KiTa or school and confirming a published pack. */

export function schoolNameQuestion(childName) {
  const who = String(childName || "").trim();
  if (who) return `Wie heisst die KiTa oder Schule von ${who}?`;
  return "Wie heisst die KiTa oder Schule?";
}

export const SCHOOL_PICK_CHILD = "Für wen?";

export function schoolConfirmQuestion(matches) {
  const list = Array.isArray(matches) ? matches : [];
  if (list.length === 1) return `Meinst du ${list[0].label}?`;
  return "Welche meinst du?";
}

export const SCHOOL_OTHER_LABEL = "Andere";
export const SCHOOL_NO_LABEL = "Nein";
